<template>
  <div>
    <div v-if="isLoading">
      <OtherLoading />
    </div>
    <div v-else>
      <div class="">
        <b-row no-gutters class="head-total p-3 h-auto">
          <b-col>
            <div class="bg-secondary">
              <p>Total QTY</p>
              <p>(จำนวนสุทธิ)</p>
              <p class="points">
                {{ transaction.total_quantity || 0 }}
              </p>
            </div>
          </b-col>
          <b-col>
            <div class="bg-secondary">
              <p>Total Amount</p>
              <p>(ราคารวม)</p>
              <p class="points">
                {{ transaction.total_amount | numeral("0,0.00") }}
              </p>
            </div>
          </b-col>
          <b-col>
            <div class="bg-secondary">
              <p>Total GP Discount</p>
              <p>(ส่วนลด GP)</p>
              <p class="points">
                {{ transaction.gp_discount | numeral("0,0.00") }}
              </p>
            </div>
          </b-col>
          <b-col>
            <div class="bg-secondary">
              <p>After GP Discount</p>
              <p>(ราคาหลังส่วนลด GP)</p>
              <p class="points">
                {{ transaction.total_after_gp_discount | numeral("0,0.00") }}
              </p>
            </div>
          </b-col>
          <b-col>
            <div class="bg-secondary">
              <p>Vat</p>
              <p>(ภาษีมูลค่าเพิ่ม)</p>
              <p class="points">
                {{ transaction.vat | numeral("0,0.00") }}
              </p>
            </div>
          </b-col>
          <b-col>
            <div class="bg-secondary">
              <p>Total Net Amount</p>
              <p>(ราคาสุทธิ)</p>
              <p class="points">
                {{ transaction.net_amount | numeral("0,0.00") }}
              </p>
            </div>
          </b-col>
        </b-row>
      </div>
      <b-row class="px-3 py-1 align-items-center">
        <!-- <b-col cols="3" class="pr-0">
          <InputText
            v-model="filter.search"
            textFloat="EAN/Article"
            placeholder="EAN/Article"
            type="text"
            @onEnter="searchProduct"
          >
            <template v-slot:text>
              <u
                @click="searchProduct"
                class="text-desc-message text-black font-weight-bold pointer"
                >ค้นหา</u
              >
            </template>
          </InputText>
        </b-col> -->
        <b-col cols="12" class="pl-4">
          <div class="d-flex justify-content-between">
            <div class="d-flex align-items-center mt-3">
              <div class="text-link-custom" @click="selectBarcode()">
                Select GP Barcode
              </div>
              <div class="ml-2" v-if="form.gp_rate">
                {{ form.gp_barcode }} : {{ form.gp_rate }} %
              </div>
            </div>
            <div class="d-flex align-items-center mt-3">
              <div class="text-link-custom" @click="changeTime()">เปลี่ยนเวลา</div>
            </div>
          </div>
        </b-col>
      </b-row>
      <template v-if="!isMobile">
        <div class="m-3">
          <b-row class="mx-0 text-center header-products">
            <b-col cols="1" class="header-products-item">
              <p>จำนวน</p>
              <p>Qty</p>
            </b-col>
            <b-col md="2" class="header-products-item">
              <p>รายละเอียดสินค้า/โปรโมชั่น</p>
              <p>Description/Promotion</p>
            </b-col>
            <b-col md="2" class="header-products-item">
              <p>หมายเลขใบเสร็จ</p>
              <p>Invoice No.</p>
            </b-col>
            <b-col class="header-products-item">
              <p>ราคาต่อหน่วย</p>
              <p>Unit Price</p>
            </b-col>
            <b-col class="header-products-item">
              <p>ราคารวม</p>
              <p>Total</p>
            </b-col>
            <b-col class="header-products-item">
              <p>ส่วนลดรวม</p>
              <p>Total Discount</p>
            </b-col>
            <b-col class="header-products-item">
              <p>ราคาหลังหักส่วนลด</p>
              <p>Discount Price</p>
            </b-col>
            <b-col class="header-products-item">
              <p>ราคาหลังลด GP</p>
              <p>After GP Discount</p>
            </b-col>
            <b-col cols="3" xl="2" class="header-products-item">
              <p>ราคาสุทธิ</p>
              <p>Net</p>
            </b-col>
          </b-row>
        </div>
        <div class="product-list-container px-3">
          <div class="item-products" v-if="form.products.length > 0">
            <b-row
              v-for="(product, index) in form.products"
              :key="index"
              :class="[
                'product-panel align-items-center mx-0 mb-2 py-1',
                { selected: productSelected.index == index },
              ]"
            >
              <b-col cols="1" class="text-center border-product py-2">
                <p>
                  <font-awesome-icon
                    icon="minus-circle"
                    title="down-btn"
                    class="text-gray"
                  />
                </p>
                <p v-if="!clickQuantity || product.serial" class="my-0">
                  {{ product.quantity }}
                </p>
                <InputText
                  v-else-if="clickQuantity && !product.serial"
                  v-model="product.quantity"
                  class="my-1 text-quantity d-flex justify-content-center"
                ></InputText>

                <p>
                  <font-awesome-icon
                    icon="plus-circle"
                    title="up-btn"
                    class="text-gray"
                    :class="{ 'text-gray': product.is_serial }"
                  />
                </p>
              </b-col>
              <b-col md="2" class="">
                <p>{{ product.product_barcode }}</p>
                <p class="product-info">{{ product.product_name }}</p>

                <p
                  v-if="product.inventory_product_serial_number"
                  class="product-info"
                >
                  Serial Number : {{ product.inventory_product_serial_number }}
                </p>

                <p class="product-info" v-if="product.gold_type">
                  น้ำหนัก :
                  <span>{{ product.total_weight | numeral("0,0.00") }} </span>
                </p>
                <p v-if="product.promotion_detail" class="product-info">
                  {{ product.promotion_detail.textPromotion }}
                </p>
              </b-col>
              <b-col cols="2" class="price">
                {{ product.invoice_no }}
              </b-col>
              <b-col cols="1" class="price">
                <p>{{ product.price | numeral("0,0.00") }}</p>
              </b-col>
              <b-col cols="1" class="price">
                {{ product.total_price }}
              </b-col>
              <b-col cols="1" class="price">
                {{ product.discount | numeral("0,0.00") }}
              </b-col>
              <b-col cols="1" class="price">
                {{ product.after_discount_price | numeral("0,0.00") }}
              </b-col>
              <b-col cols="1" class="price">
                {{ product.after_gp_discount_price | numeral("0,0.00") }}
              </b-col>
              <b-col cols="2" class="price">
                {{ product.net_amount | numeral("0,0.00") }}

                <div
                  v-if="product.gold_type"
                  class="d-flex justify-content-center mt-2"
                >
                  <div class="">
                    <b-row class="f-10 p-0">
                      <b-col
                        class="text-right text-nowrap text-primary p-0"
                        cols="7"
                        >มูลค่าทอง
                        <font-awesome-icon
                          :id="`tooltip-gold-variable-${index}`"
                          icon="exclamation-circle"
                          class="pointer icon-exclamation"
                        />
                        <b-tooltip
                          :target="`tooltip-gold-variable-${index}`"
                          placement="left"
                        >
                          ราคาทองประจำวัน ต่อกรัม
                          {{ product.gold_price_per_gram }}
                          *
                          {{ product.weight | numeral("0,0.00") }}
                        </b-tooltip>
                      </b-col>

                      <b-col class="text-left">
                        {{ product.gold_value | numeral("0,0.00") }}
                      </b-col>
                    </b-row>

                    <b-row class="f-10 p-0">
                      <b-col
                        class="text-right text-nowrap text-primary p-0"
                        cols="7"
                        >ค่าแรงรวม VAT
                        <font-awesome-icon
                          :id="`vat-tooltip-${index}`"
                          icon="exclamation-circle"
                          class="pointer icon-exclamation"
                        />
                        <b-tooltip
                          :target="`vat-tooltip-${index}`"
                          placement="left"
                        >
                          ค่าแรงรวม = ราคาขายสินค้า - มูลค่าทอง
                        </b-tooltip>
                      </b-col>

                      <b-col class="text-left">
                        {{ product.cost_vat | numeral("0,0.00") }}
                      </b-col>
                    </b-row>

                    <b-row class="f-10 p-0">
                      <b-col
                        class="text-right text-nowrap text-primary p-0"
                        cols="7"
                        >ค่าแรงไม่รวม
                      </b-col>

                      <b-col class="text-left">
                        {{ product.cost | numeral("0,0.00") }}
                      </b-col>
                    </b-row>

                    <b-row class="f-10 p-0">
                      <b-col
                        class="text-right text-nowrap text-primary p-0"
                        cols="7"
                        >VAT
                      </b-col>

                      <b-col class="text-left">
                        {{ product.vat | numeral("0,0.00") }}
                      </b-col>
                    </b-row>
                  </div>
                </div>
                <div v-else class="d-flex justify-content-center mt-2">
                  <div class="">
                    <b-row class="f-10 p-0">
                      <b-col
                        class="text-right text-nowrap text-primary p-0"
                        cols="7"
                        >มูลค่าไม่รวม VAT
                      </b-col>

                      <b-col class="text-left">
                        {{
                          (product.after_gp_discount_price - product.vat)
                            | numeral("0,0.00")
                        }}
                      </b-col>
                    </b-row>

                    <b-row class="f-10 p-0">
                      <b-col
                        class="text-right text-nowrap text-primary p-0"
                        cols="7"
                        >VAT
                      </b-col>

                      <b-col class="text-left">
                        {{ product.vat | numeral("0,0.00") }}
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
          <div v-if="!form.products.length" class="p-2 wrap-no-product">
            <div class="no-product">
              ไม่มีสินค้าในตะกร้า<br />
              กรุณาสแกนบาร์โค้ดหรือค้นหาสินค้า
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <b-row
          class="mx-0 my-1 p-2 bg-white product-panel"
          v-for="(product, index) in form.products"
          :key="index"
        >
          <b-col
            cols="1"
            class="text-center border-product d-flex align-items-center justyfy-content-center"
          >
            <p>{{ product.quantity }}</p>
          </b-col>

          <b-col class="px-2 text-general text-nowrap">
            <b-row>
              <b-col
                cols="3"
                v-if="$store.state.config.show_product_image_on_pos == 1"
              >
                <img
                  v-if="
                    product.product_image &&
                    $store.state.config.show_product_image_on_pos
                  "
                  :src="product.product_image"
                  class="img-size-sm img-fluid"
                />
                <img
                  v-else
                  src="@/assets/images/noimg.png"
                  alt="no-image-product"
                  class="img-size-sm"
                />
              </b-col>
              <b-col class="ml-2">
                <p>{{ product.product_barcode }}</p>

                <p class="product-info">
                  {{ product.product_name }}
                </p>

                <p
                  v-if="product.inventory_product_serial_number"
                  class="product-info"
                >
                  Serial: {{ product.inventory_product_serial_number }}
                </p>

                <p class="product-info" v-if="product.gold_type">
                  น้ำหนัก :
                  <span>{{ product.weight | numeral("0,0.00") }} </span>
                </p>
              </b-col>
            </b-row>
          </b-col>

          <b-col class="pr-0 text-right">
            <div>
              <!-- <p>
                {{ product.sap_price | numeral("0,0.00") }}
              </p> -->
              <p class="normal-unit-price">
                {{ product.price | numeral("0,0.00") }}
              </p>
            </div>
          </b-col>
          <b-col cols="3" xl="2" class="price">
            <p v-if="product" class="fs-16">
              {{ product.after_gp_discount_price | numeral("0,0.00") }}
            </p>
          </b-col>
        </b-row>
      </template>
      <div class="text-right w-100">
        <b-button
          variant="primary-color"
          class="btn-main-custom mr-1 my-2 px-4"
          :disabled="form.products.length == 0"
          @click="sendForm()"
        >
          <div class="d-flex align-items-center">ออก Invoice</div>
        </b-button>
      </div>
  
    </div>

    <ModalSelectBarcode
      ref="modalBarcodeList"
      @selectBarcode="handleSelectBarcode"
      @unselectItem="handleSelectBarcode"
      :branchId="branchId"
      :productList="form.products"
    />
    <ModalChangeTime
      ref="modalChangeTime"
      :branchId="branchId"
      @success="(val) => (form.due_time = val)"
    />
  </div>
</template>
<script>
import OtherLoading from "@/components/loading/OtherLoading";
import { mapGetters } from "vuex";
import ModalProductList from "../home/components/ModalProductList.vue";
import ModalSelectBarcode from "../home/components/ModalSelectBarcode.vue";
import ModalChangeTime from "./component/ModalChangeTime.vue";
export default {
  components: {
    OtherLoading,
    ModalProductList,
    ModalSelectBarcode,
    ModalChangeTime,
  },
  data() {
    return {
      isMobile: false,
      form: {
        product_group_barcode_detail_id: 0,
        total_amount: 0,
        gp_discount: 0,
        vat: 0,
        net_amount: 0,
        branch_id: 0,
        user_transaction_status_id: 1,
        products: [
          //   {
          //     product_id: 456,
          //     inventory_product_serial_id: 789,
          //     price: 500.0,
          //     after_discount_price: 450.0,
          //     quantity: 1,
          //     gold_ratio_excluding_vat: 0.0,
          //     gold_price_per_gram: 0.0,
          //     gold_minimum_goldsmith_charge: 0.0,
          //     gold_vat_variable_value: 0.0,
          //     gold_type: 3,
          //     weight: 0.0,
          //   },
        ],
        due_time: null,
        gp_barcode: "",
        gp_rate: "",
      },
      productSelected: {
        id: 0,
        quantity: 0,
        custom_price: null,
        group_barcode: "",
        sap_discount: [],
        item_discount: [],
        index: 0,
      },
      transaction: {
        total_price: 0,
        vat: 0,
        price: 0,
        total_vat: 0,
        total_cost: 0,
        total_cost_vat: 0,
        total_gold_value: 0,
        discount: 0,
        price_with_no_discount: 0,
        product_detail: [],
        quantity: 0,
      },
      isLoading: false,
      filter: {
        search: "",
      },
      gpBarcode: "",
      clickQuantity: false,
      stockList: [],
      selectedStock: "",
      showModalStock: false,
    };
  },
  computed: {
    ...mapGetters({
      dateTimeFix: "getDateTimeFix",
      branchId: "getBranchId",
      userGuid: "getUserGuid",
    }),
  },

  async created() {
    await this.getStockList();
  },
  methods: {
    async searchProduct() {
      if (!this.form.gp_rate) {
        this.warningAlert("กรุณาเลือก GP Barcode");
        return;
      }
      let user = {
        user_guid: this.userGuid,
        branch_id: this.branchId,
      };
      this.$refs.modalProductList.show(user, this.filter.search);
    },
    async addProduct(product, key) {
      this.form.products.push({
        ...product,
        quantity: 1,
        inventory_product_serial_id: null,
      });
    },

    async selectBarcode(product, index) {
      this.$refs.modalBarcodeList.show(0, index);
    },
    async handleSelectBarcode(barcode_group) {
      this.form.gp_rate = barcode_group.gp_rate;
      this.form.gp_barcode = barcode_group.gp_barcode;
      this.form.product_group_barcode_detail_id = barcode_group.id;

      await this.TransactionList();
      this.$refs.modalBarcodeList.hide();
    },
    async TransactionList() {
      const res = await this.axios.post(
        `${this.$baseUrl}/InvoiceConsignment/gp/TransactionList`,
        {
          branch_id: this.branchId,
          gp_barcode_id: this.form.product_group_barcode_detail_id,
        }
      );
      this.transaction = res.detail;
      this.form.products = res.detail.products.map((x) => ({
        ...x,
      }));
    },

    getStockList() {
      this.axios
        .get(`${this.$baseUrl}/InvoiceConsignment/GetStockList`)
        .then((data) => {
          if (data.result == 1) {
            this.stockList = data.detail;
          } else {
            this.warningAlert(data.message);
          }
        });
    },
    hide() {
      this.showModalStock = false;
      this.selectedStock = "";
    },
    showModalSelectStock() {
      let isValidSerial = this.form.products.some(
        (el) => el.is_serial == 1 && !el.inventory_product_serial_id
      );
      if (isValidSerial) {
        this.warningAlert("กรุณาระบุ Product Serial ให้ครบถ้วน");
        return;
      }
      this.showModalStock = true;
      this.selectedStock = "";
    },
    changeTime() {
      this.$refs.modalChangeTime.show();
    },

    async sendForm() {
      this.form.products = this.form.products.map((x) => ({
        ...x,
        ref_user_transaction_product_id: x.user_transaction_product_id,
      }));
      this.form.branch_id = this.branchId;
      this.form.total_amount = this.transaction.price_with_no_discount;
      this.form.gp_discount = this.transaction.discount;
      this.form.vat = this.transaction.vat;
      this.form.net_amount = this.transaction.price;

      await this.axios
        .post(`${this.$baseUrl}/InvoiceConsignment/gp/create`, {
          ...this.form,
          net_amount: this.transaction.net_amount,
          total_amount: this.transaction.total_amount,
          gp_discount: this.transaction.gp_discount,
        })
        .then((data) => {
          if (data.result == 1) {
            this.successAlert();
            this.$router.push("/gp-consignment/");
          } else {
            console.log("error");
            this.warningAlert(data.message);
          }
        });
    },
    onResize() {
      this.isMobile = window.innerWidth < 768;
    },
  },
  mounted() {
    this.onResize();
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
};
</script>
<style lang="scss" scoped>
.head-total {
  p {
    text-align: center;
    color: var(--primary-color) !important;
    font-size: 14px;
    font-weight: 600;
  }

  display: flex;
  gap: 8px;
  flex-wrap: wrap;

  .col-sm-6 {
    min-width: 133px;
    flex: 1;
    max-width: 100%;
  }
}

.head-total {
  .col:first-of-type {
    padding-left: 0;
  }

  .col:last-of-type {
    padding-right: 0;
  }

  .bg-secondary {
    height: 100%;
    padding: 15px 0 10px 0;
    background: var(--secondary-color) !important;
  }
}

.text-link-custom {
  color: var(--primary-color) !important;
  text-decoration: underline;
  font-weight: 500;
  cursor: pointer;
}

.item-products {
  color: #707070;
  font-size: 16px;
  border-radius: 8px;

  svg {
    color: #000;
  }

  .price {
    font-size: 14px;
    text-align: center;
  }

  .product-info {
    font-size: 12px;
  }

  .normal-unit-price {
    text-decoration: line-through;
  }
}

.product-panel {
  background-color: rgb(244, 244, 244) !important;

  &.selected {
    background-color: #bababa2e !important;
  }
}

.delete-credit {
  background-color: #000 !important;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  padding: 4px;
  text-align: center;

  svg {
    color: white;
    font-size: 16px;
  }
}

.product-info {
  font-size: 12px;
}

.header-products {
  font-size: 14px;
  font-weight: bold;
  gap: 4px;

  .header-products-item {
    padding: 0px;
  }
}

.product-list-container {
  overflow: auto;
  height: calc(100% - 46px - 89px - 87px - 40px);
  position: relative;

  .wrap-no-product {
    width: 100%;
    height: 100%;
    display: -ms-flexbox !important;
    display: flex !important;
    -ms-flex-pack: center !important;
    justify-content: center !important;
    -ms-flex-align: center !important;
    align-items: center !important;

    .no-product {
      text-align: center;
      font-size: 20px;
      padding: 15px;
      background-color: #f7f7f7;
      border-radius: 5px;
      color: #dcdcdc;
      width: 450px;
    }
  }
}

label {
  color: #333 !important;
  font-size: 14px !important;
  font-weight: bold !important;
}

.img-size-sm {
  width: 50px;
  height: 50px;
}
</style>
